// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__zx2Uo","modalFooterButton":"ModalNotes_modalFooterButton__3znFB"};